var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlackinline = function SvgSlackinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#slack_inline_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M5.867 0a1.6 1.6 0 0 0-1.48.988 1.6 1.6 0 0 0 .348 1.743 1.6 1.6 0 0 0 1.132.469h1.6V1.6A1.6 1.6 0 0 0 6.479.122 1.6 1.6 0 0 0 5.867 0m0 4.267H1.6a1.6 1.6 0 0 0-1.479.988 1.6 1.6 0 0 0 .347 1.742 1.6 1.6 0 0 0 1.132.47h4.267a1.6 1.6 0 0 0 1.478-.989A1.6 1.6 0 0 0 7 4.736a1.6 1.6 0 0 0-1.132-.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M16 5.867a1.6 1.6 0 0 0-.987-1.478 1.6 1.6 0 0 0-1.745.347 1.6 1.6 0 0 0-.468 1.13v1.6h1.6a1.6 1.6 0 0 0 1.479-.988c.08-.194.121-.401.12-.611m-4.267 0V1.6A1.598 1.598 0 0 0 9.52.122 1.6 1.6 0 0 0 8.533 1.6v4.267a1.596 1.596 0 0 0 1.6 1.6 1.6 1.6 0 0 0 1.479-.989c.08-.194.121-.401.121-.611"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M10.133 16a1.605 1.605 0 0 0 1.479-.988 1.6 1.6 0 0 0-.347-1.743 1.6 1.6 0 0 0-1.132-.469h-1.6v1.6a1.6 1.6 0 0 0 .987 1.478c.195.08.403.122.613.122m0-4.267H14.4a1.6 1.6 0 0 0 1.479-.988 1.6 1.6 0 0 0 0-1.224 1.6 1.6 0 0 0-1.48-.988h-4.266a1.6 1.6 0 0 0-1.479.988 1.6 1.6 0 0 0 .347 1.743 1.6 1.6 0 0 0 1.132.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M0 10.133a1.595 1.595 0 0 0 .987 1.478 1.6 1.6 0 0 0 1.745-.347 1.6 1.6 0 0 0 .468-1.13v-1.6H1.6a1.6 1.6 0 0 0-1.479.988c-.08.194-.121.402-.121.612m4.267 0V14.4a1.6 1.6 0 0 0 .987 1.478 1.605 1.605 0 0 0 1.745-.347 1.6 1.6 0 0 0 .468-1.131v-4.266a1.6 1.6 0 0 0-.988-1.478 1.6 1.6 0 0 0-1.744.347 1.6 1.6 0 0 0-.468 1.13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "slack_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSlackinline;